import { useCallback, useEffect, useState } from "react";
import { MailWarning } from "lucide-react";
import { adminApi } from "@/lib/auth";
import { logWarn } from "@/lib/log";

const when = (iso) =>
  new Date(iso).toLocaleString("es-ES", {
    day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit",
  });

const EFFECT = {
  recepcion: "Los pedidos nuevos no se están cargando.",
  remesas: "Las remesas no se están marcando como cobradas.",
  drive: "La documentación no se puede subir: vuelve a conectar Google Drive en Recepción.",
};

// Franja roja fija del Espacio Gestor cuando un buzón (Recepción o remesas)
// lleva más de 1 hora sin poder leerse o Google Drive se ha desconectado.
// Se comprueba cada 5 minutos.
export const MailboxAlertBanner = ({ onGoToReception }) => {
  const [alerts, setAlerts] = useState([]);

  const load = useCallback(async () => {
    try {
      const res = await adminApi.get("/admin/mailboxes/health");
      setAlerts(res.data?.alerts || []);
    } catch (e) {
      logWarn("No se pudo comprobar los buzones", e);
    }
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, 5 * 60 * 1000);
    return () => clearInterval(t);
  }, [load]);

  if (!alerts.length) return null;
  return (
    <div className="bg-red-700 text-white" role="alert" data-testid="mailbox-alert-banner">
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-2 flex items-center gap-3 sm:gap-4">
        <MailWarning className="h-5 w-5 shrink-0" />
        <div className="flex-1 text-sm leading-snug">
          {alerts.map((a) => (
            <p key={a.mailbox} data-testid={`mailbox-alert-${a.mailbox}`}>
              <b>
                {a.mailbox === "drive"
                  ? "Google Drive desconectado"
                  : `No se puede leer el correo de ${a.label}`}
              </b>
              <span className="hidden sm:inline">{a.address ? ` (${a.address})` : ""}</span>
              {" "}desde el {when(a.failing_since)}: {a.reason}.
              <span className="hidden sm:inline"> {EFFECT[a.mailbox]}</span>
            </p>
          ))}
        </div>
        <button
          type="button"
          onClick={onGoToReception}
          className="shrink-0 rounded-md border border-white/70 px-2.5 py-1.5 text-[11px] font-bold uppercase tracking-wide hover:bg-white hover:text-red-800 transition-colors"
          data-testid="mailbox-alert-go"
        >
          <span className="sm:hidden">Ver</span>
          <span className="hidden sm:inline">Ir a Recepción</span>
        </button>
      </div>
    </div>
  );
};
